import styled from "styled-components";

export const Container = styled.div`
    background: #9d8189;
    padding: 1rem;
`;

export const Content = styled.div`
    padding: 2rem;
    display: flex;
    justify-content: center;
`;

export const Nav = styled.nav`
    color: #ffffff !important;
`;

export const ContentList = styled.ul`
    display:inline;
    list-style: none;
`;

export const List = styled.li`
    float: left;    
    font-size: 2rem; 
`;

export const Link = styled.p`
    color: #ffffff;
    margin: 0 5rem;
    cursor: pointer;
`;